import React from 'react';
import { useViewlogies } from 'context';
import { capitalizeFirst } from 'utils';

const STEPS = [
    { key: 'getStarted', label: 'Get Started', number: 1 },
    { key: 'selectPackage', label: 'Select Care Package', number: 2 },
    { key: 'reviewOrder', label: 'Review Order', number: 3 },
    { key: 'submitPayment', label: 'Submit Payment', number: 4 },
];

const STEP_NUMBERS = {
    getStarted: 1,
    selectPackage: 2,
    reviewOrder: 3,
    submitPayment: 4,
};

const StepIndicator = ({ currentStep, lastName }) => {
    const {
        event: { color },
    } = useViewlogies();

    const activeNumber = STEP_NUMBERS[currentStep] || 1;

    return (
        <div className="care-package-step-indicator">
            <h2 className="care-package-step-heading">
                Send support to the {capitalizeFirst(lastName)} family&hellip;
            </h2>
            <div className="care-package-steps">
                {STEPS.map((step, index) => {
                    const isActive = step.number === activeNumber;
                    const isComplete = step.number < activeNumber;
                    const highlighted = isActive || isComplete;

                    return (
                        <React.Fragment key={step.key}>
                            <div className="care-package-step">
                                <div
                                    data-testid={`step-circle-${step.number}`}
                                    className={`care-package-step-circle${highlighted ? ' active' : ''}`}
                                    style={
                                        highlighted ? { backgroundColor: color, borderColor: color, color: '#fff' } : {}
                                    }
                                >
                                    {step.number}
                                </div>
                                <span
                                    className={`care-package-step-label${isActive ? ' active' : ''}`}
                                    style={isActive ? { color } : {}}
                                >
                                    {step.label}
                                </span>
                            </div>
                            {index < STEPS.length - 1 && <div className="care-package-step-line" />}
                        </React.Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default StepIndicator;
